import { useState } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Button,
    ButtonToolbar,
    Schema,
    Input,
    SelectPicker,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";
import AuthUser from "../../services/AuthUser";

const TextField = ({ name, label, accepter, ...rest }) => (
    <Form.Group controlId={name}>
        <Form.ControlLabel>{label} </Form.ControlLabel>
        <Form.Control name={name} accepter={accepter} {...rest} />
    </Form.Group>
);
const { StringType } = Schema.Types;
const model = Schema.Model({
    investor_name: StringType().isRequired("This field is required."),
    investor_number: StringType().isRequired("This field is required."),
    investor_email: StringType().isRequired("This field is required."),
});

const InquiryForm = ({ onSubmit, property }) => {
    const { plot_details } = property;

    let optionArr = [];
    if (plot_details) {
        plot_details.map((plot, index) => {
            optionArr.push({ name: plot.plot_no });
        });
    }

    const [option, setOption] = useState(optionArr[0]);
    let { user } = AuthUser();
    const [formValue, setFormValue] = useState({
        property_id: property.property_id,
        user_id: user ? user.id : "",
        plot_no: option ? option.name : 0,
        investor_name: user ? user.name : "",
        investor_number: user ? user.phone : "",
        investor_email: user ? user.email : "",
        details: "",
    });

    function handleChange(evt) {
        const value = evt.target.value;
        setFormValue({
            ...formValue,
            [evt.target.name]: value,
        });
    }

    return (
        <Form
            model={model}
            fluid
            onChange={setFormValue}
            formValue={formValue}
            onSubmit={() => onSubmit(formValue)}
        >
            <h3>Property Inquiry</h3>

            <TextField
                name="investor_name"
                label="Name"
                type="text"
                placeholder="Your full name"
                value={formValue.investor_name}
            />
            <TextField
                name="investor_number"
                label="Phone"
                placeholder="Your phone number"
                value={formValue.investor_number}
            />
            <TextField
                name="investor_email"
                label="Email"
                placeholder="Your email address"
                value={formValue.investor_email}
            />
            <Form.Group>
                <Form.ControlLabel>Select Plot</Form.ControlLabel>
                <SelectPicker
                    name="plot_no"
                    defaultValue={option ? option.name : 0}
                    cleanable={false}
                    searchable={false}
                    data={optionArr}
                    labelKey="name"
                    valueKey="name"
                    onSelect={(_v, item) => {
                        setOption(item);
                    }}
                    style={{ width: "100%" }}
                />
            </Form.Group>
            <Form.Group>
                <Form.ControlLabel>Details</Form.ControlLabel>
                <textarea
                    className="rs-input"
                    rows={3}
                    placeholder="Inquiry details"
                    name="details"
                    onChange={handleChange}
                    value={formValue.details}
                ></textarea>
            </Form.Group>
            <ButtonToolbar>
                <Button
                    appearance="default"
                    className="btn-thm w-100"
                    type="submit"
                >
                    Inquiry Now
                </Button>
            </ButtonToolbar>
        </Form>
    );
};

export default InquiryForm;
